import React, { useEffect, useState } from "react";
import { Container } from "./style";
import Input from "../../../../components/FormElement/Search";
import Button from "../../../../components/FormElement/Button";
import Spinner from "../../../../components/Spinner/FullScreen";
import ImageUpload from "../../../../components/FormElement/ImageUpload";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useHideModal } from "../../../../hooks";
import LangTab from "../../../../components/FormElement/LangTab";
import service from "../../../../services/ourteam";
import section from "../../../../services/section";
import Select from "../../../../components/FormElement/Select";
import { useShowAlert } from "../../../../hooks/useAlerts";

const Form = ({ id, fetch }) => {
  const { hideModal } = useHideModal();
  const { error } = useShowAlert();
  const [loading, setLoading] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [language, setLanguage] = useState("UZL");

  const validationSchema = Yup.object({
    full_name: Yup.object().shape({
      UZL: Yup.string().required("Kiritish shart!"),
      UZK: Yup.string().required("Kiritish shart!"),
      RUS: Yup.string().required("Kiritish shart!"),
      ENG: Yup.string().required("Kiritish shart!"),
    }),
    position: Yup.object().shape({
      UZL: Yup.string().required("Kiritish shart!"),
      UZK: Yup.string().required("Kiritish shart!"),
      RUS: Yup.string().required("Kiritish shart!"),
      ENG: Yup.string().required("Kiritish shart!"),
    }),
    department_id: Yup.string().required("Kiritish shart!"),
    fileList: Yup.array().min(1).required("Kiritish shart!"),
  });

  const formik = useFormik({
    initialValues: {
      full_name: {
        UZL: "",
        UZK: "",
        RUS: "",
        ENG: "",
      },
      department_id: "",
      position: {
        UZL: "",
        UZK: "",
        RUS: "",
        ENG: "",
      },

      fileList: [],
    },
    validationSchema,
    onSubmit: (values) => {
      const formData = new FormData();
      formData.append("full_name[UZL]", values.full_name.UZL);
      formData.append("full_name[RUS]", values.full_name.RUS);
      formData.append("full_name[UZK]", values.full_name.UZK);
      formData.append("full_name[ENG]", values.full_name.ENG);
      formData.append("position[UZL]", values.position.UZL);
      formData.append("position[RUS]", values.position.RUS);
      formData.append("position[UZK]", values.position.UZK);
      formData.append("position[ENG]", values.position.ENG);
      formData.append("department_id", values.department_id);
      fileList?.forEach((el) => {
        if (el.originFileObj) {
          formData.append(`file`, el.originFileObj);
        }
      });
      setLoading(true);
      if (id) {
        service
          .update(id, formData)
          .then(() => {
            hideModal();
            fetch();
            formik.resetForm();
          })
          .catch((err) => {
            console.log(err);
            error(
              "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
            );
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        service
          .create(formData)
          .then(() => {
            hideModal();
            fetch();
            formik.resetForm();
          })
          .catch((err) => {
            console.log(err);
            error(
              "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
            );
          })
          .finally(() => {
            setLoading(false);
          });
      }
    },
  });

  useEffect(() => {
    if (id) {
      setLoading(true);
      service
        .getOne(id)
        .then((resp) => {
          formik.setValues({
            full_name: {
              UZL: resp?.full_name?.UZL,
              UZK: resp?.full_name?.UZK,
              RUS: resp?.full_name?.RUS,
              ENG: resp?.full_name?.ENG,
            },
            position: {
              UZL: resp?.position?.UZL,
              UZK: resp?.position?.UZK,
              RUS: resp?.position?.RUS,
              ENG: resp?.position?.ENG,
            },
            department_id: resp?.department_id,
            fileList: resp?.photo ? resp?.photo : [],
          });
          resp?.photo && setFileList([resp?.photo]);
        })
        .catch((err) => {
          console.log(err);
          error(
            "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
          );
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, []);

  useEffect(() => {
    formik.setFieldValue("fileList", fileList);
  }, [fileList]);

  useEffect(() => {
    setLoading(true);
    section
      .getAll()
      .then((resp) => {
        setDepartments(resp);
      })
      .catch((err) => {
        console.log(err);
        error(
          "Server bilan bog'lanishda xatolik yuzaga keldi. Iltimos qaytadan urinib ko'ring"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const onLangChange = (key) => {
    setLanguage(key);
  };
  if (loading) return <Spinner />;
  return (
    <Container>
      <form onSubmit={formik.handleSubmit}>
        <LangTab defaultActiveKey="1" onChange={onLangChange} />
        <Input
          id="full_name"
          name="full_name"
          label="F.I.SH"
          width={100}
          placeholder="To'liq ismi"
          onChange={(e) => {
            formik.setFieldValue(`full_name.${language}`, e.target.value);
          }}
          value={formik.values?.full_name[language]}
          status={
            formik?.errors?.full_name && formik.touched.full_name ? "error" : ""
          }
        />
        <div className="item">
          <Select
            id="department_id"
            name="department_id"
            label={"Bo'lim tanlang"}
            options={departments?.map((item) => ({
              value: item?.id,
              label: item?.title,
            }))}
            onChange={(e) => formik.setFieldValue("department_id", e)}
            value={formik.values.department_id}
            status={
              formik?.errors?.department_id && formik.touched.department_id
                ? "error"
                : ""
            }
          />
        </div>
        <Input
          id="position"
          name="position"
          label="Lavozimi"
          width={100}
          placeholder="Lavozimi"
          onChange={(e) => {
            formik.setFieldValue(`position.${language}`, e.target.value);
          }}
          value={formik.values?.position[language]}
          status={
            formik?.errors?.position && formik.touched.position ? "error" : ""
          }
        />
        <div className="upload-wrapper">
          <ImageUpload
            maxCount={1}
            multiple={true}
            fileList={fileList}
            setFileList={setFileList}
            status={
              formik?.errors?.fileList && formik.touched.fileList ? true : false
            }
          />
        </div>
        <Button
          text={id ? "Tahrirlash" : "Saqlash"}
          htmlType="submit"
          width="100%"
        />
      </form>
    </Container>
  );
};

export default Form;
